//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    selected: {
      type: Object,
      default() {
        return {}
      }
    },
    stoneIndex: {
      type: Number,
      default() {
        return 0
      }
    },
    stoneTypes: {
      type: Array,
      default() {
        return []
      }
    },
    stoneShapes: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      margin: 0,
    }
  },
  computed: {
    title() {
      if(this.info.theme.id === this.constProductThemes().initialPendant || this.info.theme.id === this.constProductThemes().ringInitial || this.info.theme.id === this.constProductThemes().ringInitialNoPave || this.info.theme.id === this.constProductThemes().mosaicPendant) {
        return this.$t('selectYourInitial')
      }  else{
        return this.$t('stoneShape')
      }
    },
  },
  methods: {
    changeST(item) {
      let temp = this.$route.query.configId.split(',').filter((el, i) => i);
      const connectedConfigurationsLength = temp?.length;
      let arr = this.$route.query.configId.split(',')[0].split('-');
      let sizes = this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().ringSize || item.attribute_group === this.constAttributeGroups().necklaceSize).map(item => {
        return {...item, title: item.name}
      });
      let index = sizes.length ? 2 : 1;
      arr.forEach((it, i) => {
        if (i && i < (arr.length - index) && i === (this.stoneIndex + 1)) {
          if (arr[i].substr(2) !== item.value) {
            arr[i] = arr[i].substr(0, 2) + item.value;
          }
        }
      })
      arr = arr.join('-');
      temp = temp.join(',');

      if (this.info.dividable_pair && this.info.request_config?.length === 2) {
        temp = arr;
      }

      const query = {...this.$route.query, configId: arr + (connectedConfigurationsLength ? ',' : '') + temp};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query}).catch(err => {});
      }
    },
    changeSS(item) {
      let temp = this.$route.query.configId.split(',').filter((el, i) => i);
      const connectedConfigurationsLength = temp?.length;
      let arr = this.$route.query.configId.split(',')[0].split('-');
      let sizes = this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().ringSize || item.attribute_group === this.constAttributeGroups().necklaceSize).map(item => {
        return {...item, title: item.name}
      });
      let index = sizes.length ? 2 : 1;
      arr.forEach((it, i) => {
        if (i && i < (arr.length - index) && i === (this.stoneIndex + 1)) {
          if (arr[i].substr(0, 2) !== item.value) {
            arr[i] = item.value + arr[i].substr(2);
          }
        }
      })
      arr = arr.join('-');
      temp = temp.join(',');

      if (this.info.dividable_pair && this.info.request_config?.length === 2) {
        temp = arr;
      }

      const query = {...this.$route.query, configId: arr + (connectedConfigurationsLength ? ',' : '') + temp};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query}).catch(err => {});
      }
    },
  },
}
